import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as moment from "moment";
import BankTranferDetailsSelect from "../../../../../../Formik/BankDetailsSelect";

import { BankTranferDetailsTextInput } from "../../../../../../Formik/BankDetailsInput";
import * as Yup from "yup";
import { Util } from "../../../../../../../../helpers/util";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const daysOptions = days.map((day, key) => (
  <option value={day} key={key}>
    {day}
  </option>
));
const validationSchema = Yup.object({
  product: Yup.string().required("Please select a product").oneOf(days),
  frequency: Yup.string()
    .required("Please select your saving period")
    .oneOf(["daily", "weekly", "monthly"]),
  email: Yup.string().email().required(),
  title: Yup.string().required(),
  review: Yup.string().required(),
  rating: Yup.number().min(1).max(10).required(),
  date: Yup.date().default(() => new Date()),
  wouldRecommend: Yup.boolean().default(false),
});

const renderError = (message) => <p className="name">{message}</p>;

const HowOftenFixed = ({ setMenu }) => {
  const [fields, setFields] = useState({
    frequency: "monthly",
    payment_date: "",
    start_date: moment().add(1, "day").format("yyyy-MM-DD"),
    duration: 0,
  });

  const handleNextClick = () => {
    const payload = Util.get("create_fixed_plan", fields);
    Util.set("create_fixed_plan", { ...payload, ...fields });

    setMenu(9);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFields({ ...fields, [name]: value });
  };

  return (
    <div className="create-flexible-plan">
      <div className="create-flexible-plan-main">
        <div className="create-flexible-header">
          <h5 className="create-flexible-h5">Create Fixed Plan</h5>
          <p className="create-flexible-p">
            Save strictly for your goals and earn 7% interest rate every 30 days
          </p>
        </div>
        <div className="savest-amount-tosave">
          <p className="savest-amount-p">How often would you like to save ? </p>
          <input
            type="radio"
            id="html"
            name="frequency"
            onChange={handleInputChange}
            value="daily"
            className=" mt-3"
          />
          <label htmlFor="" className="savest-plan-label">
            Daily
          </label>
          <br />
          <input
            type="radio"
            id="html"
            name="frequency"
            onChange={handleInputChange}
            value="weekly"
            className=" mt-4"
          />
          <label htmlFor="" className="savest-plan-label">
            Once a week
          </label>

          <br />
          <input
            type="radio"
            id="html"
            name="frequency"
            onChange={handleInputChange}
            value="monthly"
            className=" mt-4"
          />
          <label htmlFor="" className="savest-plan-label">
            Once a month
          </label>
        </div>
        <div className="amount-targeted">
          <p className="savest-amount-p2 mt-5">Payment date</p>
          <Formik
            initialValues={{
              amount: "",
            }}
            onSubmit={(values, { setSubmittimg, setFieldError }) => {
              console.log(values);
            }}
            validationSchema={Yup.object({
              amount: Yup.string().required("Payment Date Field is Required"),
            })}
          >
            {({ isSubmitting }) => (
              <Form>
                {/* <BankTranferDetailsTextInput
                  name="payment_date"
                  onChange={handleInputChange}
                  value={fields.payment_date}
                  type="tel"
                  placeholder="Monday"
                /> */}

                <BankTranferDetailsSelect
                  onChange={handleInputChange}
                  name="payment_date"
                  as="select"
                >
                  <option className="select-day">Select a Day</option>
                  {daysOptions}
                </BankTranferDetailsSelect>
                <ErrorMessage name="name" render={renderError} />
              </Form>
            )}
          </Formik>
          <p className="savest-amount-p2 mt-5">
            When would you like to start saving?
          </p>
          <Formik
            initialValues={{
              amount: "",
            }}
            onSubmit={(values, { setSubmittimg, setFieldError }) => {
              console.log(values);
            }}
            validationSchema={Yup.object({
              amount: Yup.string().required("Date Field is Required"),
            })}
          >
            {({ isSubmitting }) => (
              <Form>
                <BankTranferDetailsTextInput
                  name="start_date"
                  type="date"
                  value={fields.start_date}
                  onChange={handleInputChange}
                  placeholder="DD/MM/YYYY"
                />
              </Form>
            )}
          </Formik>
          {/* <input type="text" name="" id="" className="savest-flexible-input" /> */}
        </div>

        <div className="savest-amount-tosave">
          <p className="savest-amount-p">
            How long would you like to save for this plan?
          </p>
          <input
            type="radio"
            id="html"
            name="duration"
            value={30 * 3}
            onChange={handleInputChange}
            className=" mt-3"
          />
          <label htmlFor="" className="savest-plan-label">
            3 months
          </label>
          <br />
          <input
            type="radio"
            id="html"
            name="duration"
            value={30 * 6}
            onChange={handleInputChange}
            className=" mt-4"
          />
          <label htmlFor="" className="savest-plan-label">
            6 months
          </label>

          <br />
          <input
            type="radio"
            id="html"
            name="duration"
            value={30 * 12}
            onChange={handleInputChange}
            className=" mt-4"
          />
          <label htmlFor="" className="savest-plan-label">
            1 year
          </label>
          <br />
          {/* <input
            type="radio"
            id="html"
            name="fav_language"
            value="HTML"
            className=" mt-4"
          />
          <label htmlFor="" className="savest-plan-label">
            Custom Preferred Duration
          </label> */}
        </div>

        <button onClick={handleNextClick} className="savest-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default HowOftenFixed;
